<template lang="pug">
  b-modal(
    v-model="show",
  )
    template(v-slot:modal-header).modal-header
      img.mr-2(src="../../assets/warning_modal_icon.svg")
      h5.modal-title {{dialog.title}}
    b-container(fluid, v-html="dialog.context")
    div(slot="modal-footer", class="w-100")
      b-btn(
        class="float-right ml-1"
        v-for="(button, index) in dialog.buttons"
        :key="index"
        :size="button.size"
        :variant="button.color"
        @click="button.action(close)"
      ) {{button.text}}
      b-btn(
        class="float-right ml-1"
        size="sm"
        variant="secondary"
        @click="onClickCancel"
      ) {{$t('cancel')}}
</template>

<script>
import _ from 'lodash'

const defaultValues = {
  size: 'lg',
  title: '',
  context: '',
  buttons: [],
  headerBgVariant: 'light',
  headerTextVariant: 'dark',
  bodyBgVariant: 'light',
  bodyTextVariant: 'dark',
  footerBgVariant: 'light',
  footerTextVariant: 'dark'
}

export default {
  name: 'warning-dialog',
  methods: {
    close () {
      this.show = false
    },
    onClickCancel () {
      this.show = false
    },
  },
  created () {
    this.dialog = defaultValues
    this.AppState.$on('show-warning-dialog', data => {
      this.dialog = _.assign(this.dialog, data)
      this.show = true
    })
  },
  data () {
    return {
      show: false,
      dialog: {}
    }
  }
}
</script>

<!--<style lang="scss" scoped src="./dialogs.scss"></style>-->
<style lang="scss" scoped>
::v-deep .modal-header {
  justify-content: start;
  align-items: center;
  background-color: #FAFAFA !important;
  padding: 1rem 1rem 0.75rem 1rem;
  h5 {
    font-size: 1.1rem;
    font-weight: 550;
    color: red;
  }
}

.container-fluid {
  padding-left: 0;
  font-size: 0.9rem;
  color: #545B64;
}

::v-deep .modal-footer {
  border: none;
}

.btn-primary {
  color: white;
  &:hover {
    color: white;
  }
  &:active{
    color: white;
  }
}

.btn-secondary {
  color: #6F6F6F !important;
  background-color: #FFFFFF;
  font-weight: 400;
}

.btn-secondary:hover {
  color: black !important;
  background-color: #F7F7F7 !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

.btn-secondary:active {
  color: black !important;
  background-color: #CBCBCB !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}
</style>
